export const infoBlocksHomeData = [
  {
    iconeLight: "/assets/light/mob-loc-icon-light.png",
    iconeDark: "/assets/dark/mob-loc-icon-dark.png",
    alt: "Ícone do globo terrestre",
    subtitle: "Mobilidade total, segurança total",
    description:
      "Trabalhe com tranquilidade em qualquer lugar. Seja no escritório, em casa ou viajando, o Primatio Vault garante que todos os acessos sejam autenticados com prova de vida, mantendo você sempre protegido contra fraudes e ataques.",
  },
  {
    iconeLight: "/assets/light/fingerprint-icon-light.png",
    iconeDark: "/assets/dark/fingerprint-icon-dark.png",
    alt: "Ícone de impressão digital",
    subtitle: "Menos burocracia, mais produtividade",
    description:
      "Esqueça a complexidade de lembrar e redefinir múltiplas senhas. Nossa autenticação baseada em biometria avançada permite acesso imediato e seguro aos seus sistemas, reduzindo drasticamente o tempo gasto com procedimentos desnecessários.",
  },
];

export const infoBlocksBusinessData = [
  {
    iconeLight: "/assets/light/mob-loc-icon-light.png",
    iconeDark: "/assets/dark/mob-loc-icon-dark.png",
    alt: "Ícone do globo terrestre",
    subtitle: "Segurança",
    description:
      "Autenticação biométrica exclusiva que elimina senhas e protege o acesso aos seus sistemas.Nossa tecnologia de prova de vida garante segurança real, autenticando quem você é, e não apenas o que você sabe. Mais proteção contra fraudes, menos fricção no uso.",
  },
  {
    iconeLight: "/assets/light/fingerprint-icon-light.png",
    iconeDark: "/assets/dark/ai-icon-dark2.png",
    alt: "Ícone de robô",
    subtitle: "Inteligência Artificial Personalizada",
    description:
      "Automatize decisões e reduza tarefas manuais com inteligência feita sob medida para o seu negócio. Criamos agentes de IA treinados com os dados da sua operação. Eles aprendem com o seu contexto e atuam em atendimento, segurança, análise e muito mais. Menos esforço, mais eficiência.",
  },
  {
    iconeLight: "/assets/light/mob-loc-icon-light.png",
    iconeDark: "/assets/dark/mobile-icon-dark2.png",
    alt: "Ícone de celular",
    subtitle: "Soluções Digitais",
    description:
      "Do conceito ao app na loja. Criamos produtos digitais completos, prontos para gerar resultado.  Seja para transformar um serviço atual em aplicativo ou lançar uma nova solução, cuidamos de tudo: design, tecnologia, integração e performance. Tudo para entregar a melhor experiência ao seu usuário.",
  },
];
